module.exports = __webpack_public_path__ + "static/4-c29785319af64dc74f298fd48dc44c89.jpg";